/***** modal *****/
    var $body = $('body');
    var scrollTop;

    function bodyFixedOn() {
      scrollTop = $(window).scrollTop();  
      $body.css({position: 'fixed', top: -scrollTop, width: '100%'});
      $('section.modal_switcher').removeClass('hide').addClass('show');
    }

    function bodyFixedOff() {
      $body.css({position: '', top: '', width: 'auto'});
      $(window).scrollTop(scrollTop);
      $('section.modal_switcher').removeClass('show').addClass('hide');
    }

    $('.modal_trigger').on('click', function() {
      bodyFixedOn();
    });

    $('.modal_close').on('click', function() {
      bodyFixedOff();
    });

    $('.overlay').on('click', function() {
      bodyFixedOff();
    });
 /***** /modal *****/

/***** switcher *****/
    $(function () {
      var paraGety = function paraGety(para) {
        var pageURL = window.location.search.substring(1),
        urlValue = pageURL.split('&'), paraName;
        for(var i = 0; i < urlValue.length; i++) {
          paraName = urlValue[i].split('=');
          if (paraName[0] === para) {
            return paraName[1] === undefined ? true : decodeURIComponent(paraName[1]);
          }
        }
      };
      var result = paraGety('currency');
      var cry = (result == undefined) ? 'jpy' : (result == 'jpy') ? 'jpy' : (result == 'usd') ? 'usd' : (result == 'cad') ? 'cad' : (result == 'aud') ? 'aud' : (result == 'gbp') ? 'gbp' : (result == 'eur') ? 'eur' : (result == 'cny') ? 'cny' : (result == 'krw') ? 'krw' : (result == 'hkd') ? 'hkd' : (result == 'twd') ? 'twd' : '';
      $('section.modal_switcher > nav > dl:nth-of-type(2) > dd#'+ cry +' > a').css({background: '#000', color: '#fff'});
    });
/***** /switcher *****/

/***** accordion *****/
  $(function() {
    $('button#AddToCart').on('click', function() {
      $('p.cart-all').addClass('show');
      $('p.cart-all').css('display','initial');
    });
  });
/***** /accordion *****/

/***** announce txt *****/
  $(document).ready(function(){
    $('div.announcement-bar__message').remove();
    $('div.announcement-bar').prepend('<ul><li class="fadeout">日本/世界各国へ発送</li><li class="fadein">転送/代理購入サービス不要</li></ul>');
  });
/***** /announce txt *****/

/***** header caution *****/
$(function(){
    $(".readmore").on("click", function() {
        $(this).toggleClass("on-click");
        $(".hide-text").slideToggle(1000);
    });
}); 
/***** /header caution *****/

/***** 汎用アコーディオン *****/
  document.addEventListener('click', (event) => {
    let title = event.target.closest('.acdn_btn');
      if( title ) {
      let item = title.closest('.acdn');
      let panel = item.querySelector('.acdn_btn');
      panel.classList.toggle('acdn_show');
    }
  });
/***** /汎用アコーディオン *****/

